export const customerActionType = {
    CUSTOMER_INFO:'CUSTOMER_INFO',
    CUSTOMER_SET_PAGE: 'CUSTOMER_SET_PAGE',
    CUSTOMER_SET_INIT: 'CUSTOMER_SET_INIT',
};